import axios, { Axios } from "axios";
import noAuth from "./api-noAuth";
import api, { baseURL } from "./api";
export default class VendasRecorrentesApi {
  static getListaPlanosRecorrencia = async (
    page: any,
    RecordsPerPage: any,
    idCliente: number
  ) => {
    const response = api.get(
      `/Vendarecorrente/plano?Page=${page}&RecordsPerPage=${RecordsPerPage}&idCliente=${idCliente}`
    );
    return response;
  };

  static postPlanoRecorrencia = async (body: any, idCliente: number) => {
    const response = await api.post(
      `/Vendarecorrente/plano?idCliente=${idCliente}`,
      body
    );
    return response.data;
  };

  static getListaVendasRecorrentes = async (
    page: number,
    RecordsPerPage: number,
    idCliente: number,
    idPlano?: string 
  ) => {
    const response = await api.get(
      `/Vendarecorrente/assinatura?Page=${page}&RecordsPerPage=${RecordsPerPage}&idCliente=${idCliente}${
        idPlano ? `&idPlano=${idPlano}` : ""
      }`
    );
    return response;
  };
  
  

  static postVendaRecorrente = async (body: any, idCliente: number) => {
    const response = await api.post(
      `/Vendarecorrente/assinatura?idCliente=${idCliente}`,
      body
    );
    return response.data;
  };

  static deleteVendaRecorrente = async (id: number) => {
    const response = await api.post(
      `/Vendarecorrente/assinatura/${id}/suspender`,
      {
        id: id,
      }
    );
    return response.data;
  };

  static apioutChangePermission = async (
    idPlano: number,
    status: boolean,
    idCliente: number
  ) => {
    const response = await api.patch(
      `/VendaRecorrente/plano/${idPlano}?status=${status}&idCliente=${idCliente}`
    );
    return response.data;
  };
}
